// https://owlcarousel2.github.io/OwlCarousel2/demos/demos.html
$('document').ready(function () {
	$('.stats-items').owlCarousel({
		loop: false,
		autoplay: false,
		margin: 0,
		nav: true,
		dots: true,
		//dotsEach: true,
		responsive: {
			0: {
				items: 1,
			},
			576: {
				items: 2,
			},
			992: {
				items: 3,
			},
		}
	});
	$('.stats-items-alt').owlCarousel({
		loop: false,
		autoplay: false,
		margin: 0,
		nav: true,
		dots: true,
		items: 1,
	});
	$('.logo-items').owlCarousel({
		loop: true,
		autoplay: true,
		autoplayTimeout: 3000,
		autoplaySpeed: 1000,
		autoplayHoverPause: false,
		margin: 40,
		nav: true,
		dots: true,
		responsive: {
			0: {
				items: 2,
			},
			576: {
				items: 3,
			},
			992: {
				items: 4,
			},
		}
	});
	$('.start-slider').on('click', function (e) {
		e.preventDefault();
		$('.logo-items').trigger('play.owl.autoplay');
	});
	$('.pause-slider').on('click', function (e) {
		e.preventDefault();
		$('.logo-items').trigger('stop.owl.autoplay');
	});
	$('.testimonial-items').owlCarousel({
		loop: true,
		autoplay: false,
		autoplayTimeout: 3000,
		autoplaySpeed: 1000,
		autoplayHoverPause: false,
		margin: 30,
		nav: true,
		dots: true,
		items: 1,
	});

	$('.slider-items').owlCarousel({
		loop: false,
		autoplay: false,
		margin: 10,
		nav: true,
		dots: true,
		dotsEach: true,
		responsive: {
			0: {
				items: 1,
				//stagePadding: 30,
			},
			480: {
				items: 2,
				//stagePadding: 60,
			},
			992: {
				items: 3,
				//stagePadding: 100,
			},
		}
	});
	$('.slider-items-2').owlCarousel({
		loop: false,
		autoplay: false,
		margin: 20,
		nav: true,
		dots: true,
		dotsEach: false,
		responsive: {
			0: {
				items: 1,
				stagePadding: 30,
				margin: 10,
			},
			480: {
				items: 3,
				stagePadding: 0,
				margin: 20,
			},
			992: {
				items: 4,
				stagePadding: 60,
			},
		}
	});
	$('.slider-items-3').owlCarousel({
		loop: false,
		autoplay: false,
		margin: 10,
		nav: true,
		dots: true,
		dotsEach: false,
		responsive: {
			0: {
				items: 1,
				stagePadding: 30,
				margin: 10,
			},
			480: {
				items: 2,
				stagePadding: 60,
				margin: 20,

			},
			992: {
				items: 3,
				stagePadding: 60,
			},
		}
	});
	$('.team-slider-js').owlCarousel({
		loop: false,
		autoplay: false,
		margin: 20,
		nav: true,
		dots: true,
		dotsEach: false,
		responsive: {
			0: {
				items: 2,
				stagePadding: 30,
				margin: 20,
			},
			576: {
				items: 3,
				stagePadding: 60,
				margin: 30,
			},
			992: {
				items: 4,
				stagePadding: 60,
				margin: 40,
			},
		}
	});
	function sliderClasses() {
		$('.slider-items').each(function () {
			var total = $(this).find('.owl-item.active').length;
			$(this).find('.owl-item').removeClass('focus');
			$(this).find('.owl-item.active').each(function (index) {
				if (index === 0) {
					$(this).addClass('focus')
				}
			})
		})
	}
	sliderClasses();
	$('.slider-items').on('translated.owl.carousel', function (event) {
		sliderClasses()
	});

	$(document).on('click', '.owl-item', function () {
		owlIndex = $(this).index();
		$('.owl-stage-outer').trigger('to.owl.carousel', owlIndex);
	});

	$('.tab-target').click(function (event) {
		$('.slider-items .owl-item').removeClass('focus');
		$(this).parent().addClass('focus');
		// Prevent the default click action
		event.preventDefault();

		// Retrieve data attributes from the clicked element
		var link = $(this).data('link');
		var excerpt = $(this).data('excerpt');
		var img = $(this).data('img');
		var title = $(this).data('title'); // Assuming the title is the text of the clicked element

		// Update the corresponding elements
		$('.tab-link').attr('href', link);
		$('.tab-excerpt').text(excerpt);
		$('.tab-img').css('background-image', 'url(' + img + ')');
		$('.tab-title').text(title);

		// Scroll to the corresponding tab panel
		var headerOffset = $('.header').outerHeight(); // Get header height
		var elementPosition = $('.tab-panel').offset().top; // Get the position of the target tab
		var offsetPosition = elementPosition - headerOffset; // Adjust for header

		$('html, body').animate({
			scrollTop: offsetPosition // Smooth scroll to the adjusted position
		}, 500); // Duration of the animation in milliseconds

		$('.tab-panel .tab-link').focus();

	});

	$('.owl-next, .owl-prev, .owl-dot').attr('tabindex', '-1');
});
